import { PLAN_SPEEDS_IDS } from "~/constants/products";
import { Product } from "~/types/products";
import { normalizeOfferCode } from "./getOfferTypes";

const getOTKOfferType = (availableProducts: Product[]): string => {
  const getOverrideCodeByProductId = (productId: string | number): string | undefined => {
    const product = availableProducts.find((p) => p?.productId === productId);
    return product?.price?.overrideCode;
  };

  const fiber200OverrideCode = getOverrideCodeByProductId(PLAN_SPEEDS_IDS["200"]);
  const fiber500OverrideCode = getOverrideCodeByProductId(PLAN_SPEEDS_IDS["500"]);
  const fiber1GigOverrideCode = getOverrideCodeByProductId(PLAN_SPEEDS_IDS["1000"]);
  const fiber2GigOverrideCode = getOverrideCodeByProductId(PLAN_SPEEDS_IDS["2000"]);
  const fiber5GigOverrideCode = getOverrideCodeByProductId(PLAN_SPEEDS_IDS["5000"]);
  const fiber7GigOverrideCode = getOverrideCodeByProductId(PLAN_SPEEDS_IDS["7000"]);

  const speedsOverrideCodes: Record<string, string | undefined> = {
    "200": fiber200OverrideCode,
    "500": fiber500OverrideCode,
    "1000": fiber1GigOverrideCode,
    "2000": fiber2GigOverrideCode,
    "5000": fiber5GigOverrideCode,
    "7000": fiber7GigOverrideCode,
  };

  // Flatten to a list of present codes
  const allCodes = Object.values(speedsOverrideCodes).filter((code): code is string => Boolean(code && code.length));

  if (allCodes.length === 0) {
    return "default"; // no override codes found on any product
  }

  const normalizedReturnVisitor = normalizeOfferCode("ReturnVisitor");
  const is500ReturnVisitor = normalizeOfferCode(fiber500OverrideCode).includes(normalizedReturnVisitor);
  const is1GigReturnVisitor = normalizeOfferCode(fiber1GigOverrideCode).includes(normalizedReturnVisitor);

  const is5002monthsFree = normalizeOfferCode(fiber500OverrideCode).includes(normalizeOfferCode("2 months on us"));
  const is1Gig2monthsFree = normalizeOfferCode(fiber1GigOverrideCode).includes(normalizeOfferCode("2 months on us"));

  if (is500ReturnVisitor && fiber500OverrideCode) {
    return fiber500OverrideCode;
  }

  if (is1GigReturnVisitor && fiber1GigOverrideCode) {
    return fiber1GigOverrideCode;
  }

  if (is5002monthsFree && fiber500OverrideCode) {
    return fiber500OverrideCode;
  }

  if (is1Gig2monthsFree && fiber1GigOverrideCode) {
    return fiber1GigOverrideCode;
  }

  const is200HighValueOfferTest =
    normalizeOfferCode(fiber200OverrideCode).includes(normalizeOfferCode("High Value Offer")) &&
    normalizeOfferCode(fiber200OverrideCode).includes(normalizeOfferCode("Test"));
  const is1Gig3MonthsFree = normalizeOfferCode(fiber1GigOverrideCode).includes(normalizeOfferCode("3 Months on Us"));

  if (is200HighValueOfferTest && is1Gig3MonthsFree && fiber1GigOverrideCode) {
    return fiber1GigOverrideCode;
  }

  const allSame = allCodes.every((code) => code === allCodes[0]);
  if (allSame) {
    return allCodes[0];
  }

  return "default";
};

export default getOTKOfferType;
